import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import ConferenceList from './Components/Pages/Conference/core/ConferenceList';
import UpcomingConference from './Components/Pages/Conference/info/UpcomingConference';
import PlanScientificPage from './Components/Pages/Conference/info/PlanScientificPage';
import ConferenceProceding from './Components/Pages/Conference/core/ConferenceProceding';
import Webinar from './Components/Pages/Conference/webinar/Webinar';
import PastConference from './Components/Pages/Conference/Pastconference/Home/PastCoference';
import ConferenceGallery from './Components/Pages/Gallery/ConferenceGallery';
import ContactForm from './Components/Forms/ContactForm';
import Sponsor from './Components/Pages/Conference/info/Sponsor';
import NewWorkshop from './Components/Pages/Workshop/NewWorkShop';
import Faq from './Components/common/Faq';
import ConferenceHome from './Components/Pages/Conference/core/ConferenceHome';
import Achievements from './Components/Pages/Research/Achivements/Achivements';
import ResearchHome from './Components/Pages/Research/ResearchHome';
import Services from './Components/Pages/Services/Services';
import Products from './Components/Pages/Products/Products';
import Index from './Components/Pages/Home/Index';
import ConferencePapers from './Components/Pages/Conference/core/ConferencePapers';
import AssuranceHomePage from './Components/Pages/Thesis_work/AssuranceHomePage';
import ScrollToTop from './Components/Pages/Home/ScrollToTop';
import NotFound from './Components/common/NotFound';

const LowercaseRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== location.pathname.toLowerCase()) {
      navigate(location.pathname.toLowerCase() + location.search + location.hash, { replace: true });
    }
  }, [location, navigate]);

  return null;
};

const App = () => {
  return (
    <>
      <Router>
        <ScrollToTop />
        <LowercaseRedirect />
        <Routes>
        {/* Conference Pages */}
        <Route path="/conference-home" element={<ConferenceHome/>} />
        {/* <Route path="/conference-award" element={<ConferenceAward/>} /> */}
        <Route path="/conference-list" element={<ConferenceList/>} />
        <Route path="/upcoming-conference" element={<UpcomingConference/>} />
        <Route path="/plan-scientific-page" element={<PlanScientificPage/>} />
        <Route path="/conference-proceding" element={<ConferenceProceding/>} />
        <Route path="/conference-papers" element={<ConferencePapers/>} />

        <Route path="/webinar" element={<Webinar/>} />
        <Route path="/past-conference" element={<PastConference/>} />
        {/* <Route path="/submit-proposal-form" element={<SubmitProposalForm/>} /> */}
        <Route path="/contact-form" element={<ContactForm/>} />
        <Route path="/sponsor" element={<Sponsor/>} />
        <Route path="/workshop" element={<NewWorkshop/>} />
        <Route path="/faq" element={<Faq/>} />
        <Route path="/conference-gallery" element={<ConferenceGallery/>} />

        {/* Research Pages */}
        <Route path="/research-home" element={<ResearchHome/>} />
        <Route path="/achievements" element={<Achievements/>} />
        <Route path="/services" element={<Services/>} />
        <Route path="/products" element={<Products/>} />

        {/* Home Pages */}
        <Route path="/" element={<Index/>} />
        {/* Thesis & Academic Pages */}
        <Route path="/thesis-home" element={<AssuranceHomePage/>} />

        {/* 404 - catch all */}
        <Route path="*" element={<NotFound/>} />
      </Routes>
    </Router>
   </>
  )
}

export default App
